export const CART_UPDATE = 'CART_UPDATE';

export const CART_ITEM_UPDATE = 'CART_ITEM_UPDATE';
export const CART_ITEM_DELETE = 'CART_ITEM_DELETE';
